import axios from 'axios';

const updateUserPermissions = ({ userId, ...params }) => {
  return axios.put(`users/${userId}/permissions`, params);
};

export { updateUserPermissions };
